import React, { useState, useEffect } from 'react';
import API from '../services/api';
import './SignOffStatus.css';

const SignOffStatus = ({ incidentId }) => {
  const [signOffs, setSignOffs] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSignOffs = async () => {
      try {
        // Correct the endpoint to match the backend
        const response = await API.get(`/api/investigation/${incidentId}/sign-offs`);
        setSignOffs(response.data.signOffs);
      } catch (err) {
        console.error('Error fetching sign-off status:', err);
        setError('Failed to load sign-off status.');
      } finally {
        setLoading(false);
      }
    };

    fetchSignOffs();
  }, [incidentId]);

  if (loading) {
    return <div className="loading">Loading sign-off status...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="sign-off-status">
      <h3>Sign-Off Status</h3>
      <ul>
        <li>Delegate: {signOffs.DELEGATE_SIGN_OFF ? '✔️' : '❌'}</li>
        <li>Supervisor: {signOffs.SUPERVISOR_SIGN_OFF ? '✔️' : '❌'}</li>
        <li>Manager: {signOffs.MANAGER_SIGN_OFF ? '✔️' : '❌'}</li>
        <li>Safety Preliminary: {signOffs.SAFETY_PRELIMINARY_SIGN_OFF ? '✔️' : '❌'}</li>
        <li>Safety Final: {signOffs.SAFETY_FINAL_SIGN_OFF ? '✔️' : '❌'}</li>
        <li>CAO: {signOffs.CAO_SIGN_OFF ? '✔️' : '❌'}</li>
      </ul>
    </div>
  );
};

export default SignOffStatus;